import React from 'react'
import { observer } from 'mobx-react'
import './index.scss'
import Button from '@Components/Buttons/Button'

interface Role {
    name: string
    value: string
}

interface SearchResultProps {
    title: string
    onItemWasAdded?: (title: string) => boolean | undefined
    onAddClicked: (title: string) => void
    roles?: Role[]
    addButtonText?: string
}

const SearchResult = ({ title, onItemWasAdded, onAddClicked, roles, addButtonText }: SearchResultProps) => (
    <div className="search-result">
        <div className="item-head">
            <p className="bold">{title}</p>
            {(onItemWasAdded && onItemWasAdded(title)) || (
                <Button mainColor type="primary-small" onClick={() => onAddClicked(title)}>
                    {addButtonText ? addButtonText : 'Add'}
                </Button>
            )}
        </div>

        <ul className="item-content">
            {roles &&
                roles.map((role) => (
                    <li key={role.name}>
                        <span>{role.name}:</span>
                        <strong>{role.value}</strong>
                    </li>
                ))}
        </ul>
    </div>
)

export default observer(SearchResult)
